export default {
	text: {
		abort: 'Annuler',
		automatic: 'Automatique',
		autodrop: 'Reorganisation auto',
		bib: 'Doss',
		class: 'Cat.',
		club: 'Club',
		confirmHeatEnd: 'Terminer évènement?',
		comment: 'Commentaire',
		deviceName: 'Nom appareil',
		displayFocusWatch: 'Afficher heure de concentration',
		drop: 'Reorganiser',
		dropAfterN: 'Meilleurs {n} selon liste départ orig.',
		editValue: 'Traitement résultat',
		entrants: 'Athlètes',
		error500: 'Le serveur ne fonctionne pas, veuillez consulter l administrateur',
		errorLogin: 'Erreur login',
		errorFirstTryDrop: 'Le premier essai ne peut être reorganisé.',
		errorResultFound: 'Des résultats à cette hauteur ont été saisis. Supprimer quand-même?',
		errorInvalidInput: 'L entrée implique un résultat non valable. Veuillez contrôler!',
		errorMissingData: 'Aucune donnée trouvée',
		errorNoServerConnection: 'Aucune connexion au serveur',
		errorUnknowen: 'Erreur inconnu',
		eventOverview: 'Vue d emsemble',
		global: 'Global',
		height: 'Hauteur',
		heightManager: 'Editeur hauteurs',
		heightShort: 'm',
		hideEliminated: 'cacher les athlètes éliminés',
		interval: 'Intervalle',
		jumpOff: 'Barrage',
		language: 'Langue',
		lang: {
			'de-DE': 'Deutsch',
			'en-US': 'English (US)',
			'en-EN': 'English (UK)',
			'fr-CH': 'Français (CH)',
			'nl-NL': 'Dutch'
		},
		letIt: 'laisser',
		listView: 'Affichage liste',
		loading: 'Chargement...',
		login: 'Annonce',
		logout: 'Logout',
		manual: 'Manuel',
		message: 'Message',
		notStartetError: 'Evènement non commencé',
		name: 'Nom',
		next: 'Suivant',
		noData: 'Pas de données',
		noRankingShort: 'sEv',
		order: 'Ordre',
		orderIn: 'Tri',
		overview: "Vue d'ensemble",
		password: 'Mot de passe',
		poolMerge: 'réunir groupes',
		poolMergeMessage: {
			request: 'vraiement réunir les groupes?',
			errorToLessGroups: 'Trop peu de groupe pour la réunification',
			errorAlreadyMerged: 'Les groupes sont déjà réunis',
			errorResultsMissing: 'Ils manquent encore des résultats',
			errorResultsMissing: "La réunification n'est possible pour cet évènement",
			mergeDone: 'Les groupes ont été réunis sur un autre appareil. Transfert sur la vue des évènements',
		},
		rank: 'Rang',
		ranking: 'Rangs',
		redCard: 'Carton rouge',
		refresh: 'Charger à nouveau',
		reset: 'Rétablir',
		result: 'Résultat',
		resultEdit: 'Introduction résultat',
		save: 'Enregistrer',
		send: 'Envoyer',
		setCurrent: 'Placer devant',
		setStartHeight: 'Fixer hauteur de départ',
		settings: 'Réglages',
		seperateClasses: 'Traiter les catégories séparément',
		showEliminated: 'Affiche athlètes éliminés',
		startHeat: 'Démarrage évènement',
		status: 'Statut',
		startlist: 'Liste de départ',
		state: {
			can: 'ren.',
			dns: 'n.p.',
			dsq: 'disq.',
			finished: 'OK',
		},
		stopHeat: 'Terminer évènement',
		singleHeight: "Hauteur individuel",
		toastTimeLabel: 'Durée affichage pour messages',
		toEntrie: "A'l athlète",
		try: 'Essai',
		tryAutoLogin: 'tente autologin',
		tryShort: 'E',
		wind: 'Vent',
		windShort: 'V',
		wkbHelp: 'WKB Aide',
		yellowCard: 'Carton jaune',
	},
};
